import React from "react";

const statistics : React.FC = () => {
    return(
        <>
            Statistics  
        </>
    )
}

export default statistics